<template>
  <div id="app">
    <el-container>
      <home-head></home-head>
      <el-main class="neitong_bufen_qiangzhi">
        <div class="content">
          <el-tag  closable v-if="js_zhi"  @close="juese_sc_sj()">{{js_zhi.title}}</el-tag>
          <el-tag  closable v-if="bujian"  @close="bujian_sc_sj()" style="margin-left: 20px">{{bujian}}</el-tag>
          <el-tag  closable v-if="ly_zhi"  @close="lingyu_sc_sj()" style="margin-left: 20px">{{ly_zhi.title}}</el-tag>
          <div class="main-heads">
            <div style="width: 95%; margin: 0 auto;position: relative">
              <div v-if="aa==1">
                <i class="el-icon-arrow-down" style="position: absolute;left: 100%;top: 25px;font-size: 16px" @click="xiaoxi(aa=2)"></i>
                <div class="search-tops">行业领域：</div>
                <el-row class="search_tops_el_row">
                  <el-col :xs="8" :sm="6" :md="4" v-for="(item1,index) in yingyong_ly.slice(0,12)" :key="index">
                    <a class="a_color" @click="lingyu_sj(item1)" :title="item1.title">
                      <div  class="search-tops-title" id="showLabelAndAttrName">{{ item1.title }}
                    </div></a>
                  </el-col>
                </el-row>

              </div>
            </div>
            <div style="width: 95%; margin: 0 auto;position: relative">
              <div v-if="aa==2">
                <i class="el-icon-arrow-up" style="position: absolute;left: 100%;top: 25px;font-size: 16px" @click="xiaoxi(aa=1)"></i>
                <div class="search-tops">行业领域：</div>
                <el-row class="search_tops_el_row">
                  <el-col :xs="8" :sm="6" :md="4" v-for="(item1,index) in yingyong_ly" :key="index">
                    <a class="a_color" @click="lingyu_sj(item1)" :title="item1.title">
                      <div  class="search-tops-title" id="showLabelAndAttrName">{{ item1.title }}
                    </div></a>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>

          <div class="main-head">
            <el-row >
              <el-col :xs="8" :sm="6" :md="4" >
                <div class="search-top" @click="px_shijian2">综合排序
                  <i class="el-icon-arrow-up" v-if="is_open3==1"></i>
                  <i class="el-icon-arrow-down" v-if="is_open3==0"></i></div>
              </el-col>
<!--              <el-col :xs="8" :sm="6" :md="4" >-->
<!--                <div class="search-top" @click="px_shijian">价格-->
<!--                  <i class="el-icon-arrow-up" v-if="is_open2==1"></i>-->
<!--                  <i class="el-icon-arrow-down" v-if="is_open2==0"></i></div>-->
<!--              </el-col>-->
              <el-col :xs="8" :sm="6" :md="4" style="width: 300px">
                <div class="search-top" >地区：
                  <el-cascader class="jilian_xuanzeqi_wenzi_yangshi"
                               size="mini"
                               :options="options"
                               v-model="selectedOptions"
                               popper-class="dingdanchuangjian_xuanzhong_lika_qiangzhi_tihuan2"
                               @change="handleChange">
                  </el-cascader>
                </div>
              </el-col>
              <el-col :xs="8" :sm="6" :md="4" >
<!--                <el-checkbox v-model="checked" @change="mm_biaojia" class="chumo_yangshi_gabian_hover">明码标价</el-checkbox>-->
              </el-col>
            </el-row>
          </div>
          <el-row :gutter="35" style="margin-top: 20px;">
            <el-col :xs="12" :sm="12" :md="6"  v-for="(item,index) in list" :key="index" >
              <div class="shebei-item">
                <a v-bind:href="'#/dianpu_details/' + item.id ">
                  <div class="backgd">
                    <el-image  :src="url+'/storage/'+item.cover" fit="cover">
                      <div slot="error" class="image-slot">
                        <img src="../../../assets/home/ecc08ecd42f312b04df547040f2e5f3.png" alt="" style="height: 220px">
                        <!--                        <i class="el-icon-picture-outline"></i>-->
                      </div>
                    </el-image>
                  </div>
                  <div style="width: 100%;height: 21px">
                    <p class="prices" :title="item.title">{{item.title}}</p>
                  </div>
                  <!--                    <div class="good">好评121&nbsp;162人购买</div>-->
                  <div>
            <span class="priceses" v-if="item.price_yugu==0.00">明码标价
            <span class="money">¥</span><span class="value">{{item.cash}}</span>
            </span>
                    <span class="priceses" v-else>预估价格
                <span class="money">¥</span><span class="value">{{item.price_yugu}}</span>
                  </span>
                  </div>

                </a>
              </div>
            </el-col>
          </el-row>
          <div data-v-6af373ef="" data-v-5c2776a4="" class="pagination-container" style="line-height: 5.1em;margin-top: 60px">
            <div data-v-6af373ef="" class="el-pagination is-background">
              <span class="el-pagination__total">共 {{ zuoshuL }} 条</span>
              <el-pagination
                  style="float: left"
                  layout="prev, pager, next"
                  @current-change="yedianji"
                  :total="zuidayema*10">
              </el-pagination>
            </div>
          </div>
        </div>
      </el-main>


      <el-footer >
        <home-footer></home-footer>
<!--        <el-row class="footer footer_bottom">-->
<!--          <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20">-->
<!--            <div class="footer_width">-->
<!--              <div style="float: left; margin-right: 144px">-->
<!--                <div class="glzy_top">-->
<!--                  <a class="xuanzhong wenzi" href="">-->
<!--                    <span class="footer_text2 footer_gyyyj_left">关于仪海仪家</span>-->
<!--                  </a>-->
<!--                  <a class="xuanzhong wenzi" href="">-->
<!--                    <span class="footer_text2 footer_lxwm_left">联系我们</span>-->
<!--                  </a>-->
<!--                  <a class="xuanzhong wenzi" href="">-->
<!--                    <span class="footer_text2 footer_lxwm_left">著作权与商标声明</span>-->
<!--                  </a>-->
<!--                  <a class="xuanzhong wenzi" href="">-->
<!--                    <span class="footer_text2 footer_lxwm_left">隐私政策</span>-->
<!--                  </a>-->
<!--                </div>-->
<!--                <div class="glzy_bottom">-->
<!--                <span class="footer_text2 ">-->
<!--                  Copyright@2020 海粟智链（青岛）科技有限公司-->
<!--                  版权所有鲁ICP备 19060515号-1</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </el-col>-->
<!--          <el-col :xs="4" :sm="4" :md="4">-->
<!--            <img class="erweima" src="../../../assets/home/erweima.jpg" alt="">-->
<!--          </el-col>-->
<!--        </el-row>-->
      </el-footer>
    </el-container>
  </div>
</template>
<script>
  import home_head from '../../common/home-head';
import { regionDataPlus } from 'element-china-area-data'
  import footer from "../../common/footer";

export default {

  name: "category",
// /storage/

  data: function () {
    return {
      fits:['fill','contain','cover','none','scale-down'],
      is_open:{
        sousuo:1,
        lanmu:1,
        phone_shaixuan:0,
        phone_sousuokuang:0,
      },

      options: regionDataPlus,
      selectedOptions: [],
      list:'',
      lists:'',
      list_guige:[],
      url:'',
      zuoshuL:'',
      zuidayema:'',
      diqu:'',
      is_open2:1,
      is_open3:1,
      checked:false,
      pidzhi : 0,
      gongyelian:'',
      lingbujian:'',
      bujian:'',
      gylian:'',
      biaoqain_name:'',
      yingyong_ly:'',
      ly_zhi:'',
      js_zhi:'',
      information:'',
      qy_juese:'',
      aa:1
    }
  },
  components:{
    'home-head':home_head,
    'home-footer':footer
  },
  watch:{
    '$route.query.title':function( ){
      this.list_data();
    }
  },

  methods:{
    xiaoxi(aa){
      console.log(aa)
    },
    sousuo_xuanxiang(e){
      this.is_open.sousuo = e
      console.log(this.is_open.sousuo)
    },
    init(){
      this.information = this.$store.state.information
      this.list_data()
      // this.list_price()
      // this.gy_lian()
      this.lingyu()
      // this.gj_bujian()
      // this.juese()
      this.url = window.config.api_url
    },
    list_price(){
      var t = this
      var url = window.config.api_url+'/college/goods/'+t.$route.params.id
      t.axios.get(url).then(res=>{
        t.lists = res.data
        //  = res.data.specification
        res.data.specification.forEach(function(item) {
          t.list_guige.push({estimate:item.estimate,goods_id:item.goods_id,id:item.id,price:item.price,specification:item.specification,sum:0})
          // console.log(item)
        })

        console.log(t.list_guige)
        t.dp_inform()
      })
    },
    juese(){
      var t = this
      var url = window.config.api_url+'/college/job'
      t.axios.get(url).then(res=>{
        console.log(res)
        t.qy_juese=res.data
      })
    },
    lingyu(){
      var t = this
      var url = window.config.api_url+'/college/subject'
      t.axios.get(url).then(res=>{
        console.log(res)
        t.yingyong_ly = res.data
      })
    },
    gj_bujian(){
      var t = this
      var url = window.config.api_url+'/college/goods/parts'
      t.axios.get(url).then(res=>{
        t.lingbujian = res.data
      })
    },
    gy_lian(){
      var t = this
      var url = window.config.api_url+'/college/goods/chain'
      t.axios.get(url).then(res=>{
        t.gongyelian = res.data
        console.log(t.gongyelian)
      })
    },
    lingyu_sj(e){
      var t = this
      t.ly_zhi = e
      t.list_data()
    },
    juese_sj(e){
      var t = this
      t.js_zhi = e
      t.list_data()
    },
    bujian_sj(e){
      var t = this
      t.bujian = e
      t.list_data()
    },
    biaoqian_sc_sj(){
      var t = this
      t.pidzhi = 0
      t.fl_get()
      t.list_data()
    },
    lingyu_sc_sj(){
      var t = this
      t.ly_zhi = ''
      t.list_data()
    },
    juese_sc_sj(){
      var t = this
      t.js_zhi = ''
      t.list_data()
    },
    bujian_sc_sj(){
      var t = this
      t.bujian = ''
      t.gj_bujian()
      t.list_data()
    },
    fl_get(e){
      var t = this
      if (e){
        t.pidzhi = e.id
        t.biaoqain_name = e.name
      }
      var url = window.config.api_url+'/college/goods/cate?pid='+t.pidzhi
      t.axios.get(url).then(res=>{
        if (res.data==''){

          return console.log(res.data,908)
        }
        console.log(res.data,9018)
        t.qy_juese = res.data
      })
      if (e){
        t.list_data()
      }
    },
    list_data(e){
      var t = this
      var url = window.config.api_url+'/college/fuwu/list'
      if (e){
        url+='?paginate=12&page='+e
      }
      else {
        url+='?paginate=12&page=1'
      }
      if (t.diqu){
        url += '&province='+t.diqu[0]
        if (t.diqu[1]){
          url += '&city='+t.diqu[1]
        }
        if (t.diqu[2]){
          url += '&area='+t.diqu[2]
        }
      }
      if (t.bujian){
        url += '&parts='+t.bujian
      }
      if (t.is_open2==0){
        url += '&order=cash'
      }
      if (t.is_open3==0){
        url += '&by=desc'
      }
      if (t.is_open3==1){
        url += '&by=asc'
      }
      if (t.checked==true){
        url += '&has_price=1'
      }
      if (t.pidzhi != 0){
        url += '&cate_id='+t.pidzhi
      }
      if (t.ly_zhi){
        url += '&aac_id='+t.ly_zhi.id
      }
      if (t.js_zhi){
        url += '&aac_id='+t.js_zhi.id
      }
      // todo 添加 title 搜索
      if( this.$route.query.title ){
        url += '&title='+this.$route.query.title
      }
      t.axios.get(url).then(res=>{
        console.log("xianshi",res.data)
        t.list = res.data.data
        t.zuoshuL = res.data.total
        t.zuidayema=res.data.last_page
      })
    },
    mm_biaojia(){
      var t = this
      // console.log(1315546)
      t.list_data()
    },
    px_shijian(){
      var t = this
      if ( t.is_open2==1){
        t.is_open2 = 0
      }else {
        t.is_open2 = 1
      }
      t.list_data()
    },
    px_shijian2(){
      var t = this
      if ( t.is_open3==1){
        t.is_open3 = 0
      }else {
        t.is_open3 = 1
      }
      t.list_data()
    },
    handleChange (value) {
      this.diqu = value
      this.list_data()
    },
    yedianji(e){
      this.list_data(e)
    }
  },
  created() {
    this.init()
  }
}
</script>
<style>

.neitong_bufen_qiangzhi  .el-tag--light {
  background-color:  #4E6EF2!important;
  color: #FFFFFF!important;
}
.neitong_bufen_qiangzhi .el-pagination.is-background .el-pager li:not(.disabled):hover{
  color: #4E6EF2;

}
.neitong_bufen_qiangzhi .el-pagination.is-background .el-pager li:not(.disabled).active{
  background-color: #4E6EF2;
}
.el-checkbox__inner{
  margin-left: -15px;
}
.neitong_bufen_qiangzhi .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #666666 !important;
}
.neitong_bufen_qiangzhi .el-checkbox__inner:hover{
  border-color: #666666 !important;
}
.neitong_bufen_qiangzhi .el-checkbox__input.is-checked+.el-checkbox__label{
  color: #333333!important;
}
.neitong_bufen_qiangzhi .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: #4E6EF2!important;
  border-color: #333333!important;
}
.neitong_bufen_qiangzhi .el-cascader .el-input .el-icon-arrow-down{
  font-size: 0px!important;
  color: #666666!important;
}
.jilian_xuanzeqi_wenzi_yangshi{
  font-size: 18px!important;

}
.neitong_bufen_qiangzhi .el-input__inner{
  border: 0px!important;
}
.neitong_bufen_qiangzhi .el-tag {
  text-align: center;
  width: 120px;
  margin-top: 20px;
  padding: 0;
  height: 24px;
  line-height: 24px;
  margin-left: 2.5% !important;
}
.el-checkbox__label {
  font-size: 18px!important;
}
.el-checkbox {

  font-size: 18px!important;
}
</style>
<style lang="less" scoped>
@import "../../../../node_modules/element-ui/lib/theme-chalk/display.css";
@head_text : Source Han Sans CN;
@font-face {

}

@import "../../../assets/css/home";
@import "../../../assets/css/home_search";

</style>
